export const BlockCaseStudiesLoop = (container: HTMLElement) => {
	const CaseStudiesLoopObject = {
		loopItems: container.querySelectorAll( '.loop-item--case-study' ) as NodeListOf<HTMLElement>,
		tabNavigationLinks: container.querySelectorAll( '.tab-navigation__link' ) as NodeListOf<HTMLElement>,
		_init(): void {
			this._bindClass();
			this._bindEvents();
		},
		_bindClass(): void {
			this.toggleTab = this.toggleTab.bind(this);
		},
		_bindEvents(): void {
			this.tabNavigationLinks.forEach( (link: HTMLElement) => {
				link.addEventListener( 'click', this.toggleTab );
			} );
		},
		toggleTab(event: Event): void {
			event.preventDefault();

			const target = event.currentTarget as HTMLLinkElement;
			const href = target.href;
			const anchor = href.split('#')[1];

			console.log( anchor, this.loopItems );

			this.loopItems.forEach( (item: HTMLElement) => {
				if ( anchor === 'all' ) {
					item.style.display = 'block';
				}
				else {
					if ( item.dataset.category === anchor ) {
						item.style.display = 'block';
					}
					else {
						item.style.display = 'none';
					}
				}
			} )
		}
	};

	CaseStudiesLoopObject._init();
	return CaseStudiesLoopObject;
};
